import { asyncAction } from 'lib/actions';

export const fetchCountriesAction = asyncAction('countries/FETCH');
